/**
 * 이상한 방 - 시간 단위 상수
 *
 * 파일마다 `SECOND_MS`/`MS_PER_SECOND`/`MILLISECONDS_PER_SECOND`로 재정의하던 것을 여기로 모은다.
 * 나머지 사본(ui·render·game 층)은 후속 패스에서 옮긴다.
 */

/** 1초의 밀리초. 타이머·`performance.now()`는 ms를 쓰고 오디오 시계는 초를 써서 경계마다 곱한다. */
export const MS_PER_SECOND = 1000

/** 1분의 초. bpm(분당 박)을 초 단위 박 길이로 바꿀 때의 분자다. */
export const SECONDS_PER_MINUTE = 60

/**
 * ms → 화면의 정수 초. **올림**이고 0 아래로 내려가지 않는다 - "1초 남음"이 0으로 보이면 아직 있는 시간을 없다고 말하는 셈이고,
 * 0.2초 남은 사람을 "0"으로 적으면 이미 나온 사람으로 읽힌다. HUD의 카운트다운 · 문 앞 줄 · 쿨타임 토스트가 전부 이 하나를 쓴다 -
 * 한 줄짜리라서 사본이 넷까지 자랐고(`clamp01`과 같은 길), 두 층(`ui`·`game`)이 쓰므로 `ui/dom`이 아니라 여기다.
 */
export function ceilSeconds(ms: number): number {
  return Math.max(0, Math.ceil(ms / MS_PER_SECOND))
}
